import { ClinicalDataNameValue } from '@features/components/ClinicalData/components/ClinicalLog/LogItems/types';
import { vitalsNames } from '@features/components/ClinicalData/constants';
import { MINUTE_IN_MS } from '@/constants/date.constants';
import { convertToTimezoneOffset, toStringValue } from '@/utils/helpers';
import { VitalParameters } from '@/api/apis/case';

export const getVitalsRT = (measurementMinute: number) => {
  const readingTimeInMs = measurementMinute * MINUTE_IN_MS;

  return `RT ${convertToTimezoneOffset(readingTimeInMs, false)}`;
};

export const getVitalsWithNamesParameters = (vitalParameters?: VitalParameters): ClinicalDataNameValue[] => {
  const {
    heartRate,
    systolicBloodPressure,
    diastolicBloodPressure,
    meanArterialPressure,
    oxygenSaturation,
    respiratoryRate,
  } = vitalParameters ?? {};
  return [
    {
      name: vitalsNames.bp,
      value: `${toStringValue(systolicBloodPressure)} / ${toStringValue(diastolicBloodPressure)}`,
    },
    {
      name: vitalsNames.hr,
      value: toStringValue(heartRate),
    },
    {
      name: vitalsNames.map,
      value: toStringValue(meanArterialPressure),
    },
    {
      name: vitalsNames.rr,
      value: toStringValue(respiratoryRate),
    },
    {
      name: vitalsNames.sat,
      value: toStringValue(oxygenSaturation, '%'),
    },
  ];
};
